export default {

    content: {
        class: [
            // Font
            // 'leading-5',
            // Spacing
            'p-4',
            // Colors
            'bg-white',
            'text-gray-900',
            'border-gray-200',
            'border border-t-0',
        ]
    }
};
